import Vue from 'vue';
import { HelperFunctions } from "@/lib/utilities/HelperFunctions.js";

function initialState() {
  return {
    vendorListLoading: false,
    selectedAccount: '',
    selectedAccountInput: {},
    accountsloading: false,
    platformSelected: null,
    platformsLoading: false,
    accountErr: false,
    showAddWebsiteModal: false,
    columns: [],
    rows: [],
    accountSelectErr: false,
    platformSelectErr: false,
    editingWebsite: {},
    existingDomains: [],
    activePlatforms: [],
    DW_AccountSearchResults: [],
    vendorList: []
  }
};

const state = initialState();

const actions = {
  resetPage: function (context, data) {
    location.reload();
  },
  DW_searchAccounts: function (context, param) {
    return new Promise((resolve, reject) => {
      Vue.http.get('platform/searchdealers?accountId=' + param.accountId + '&term=' + param.searchTxt + '&internalOnly=' + param.interalOnly + '&activeOnly=' + param.activeOnly).then(function (data) {
        //console.log("results : ", data);
        data.data.Data.forEach(function (account) {
          account.LabelText = account.Account + " [" + account.AccountId + "]";
        });
        context.commit('updateSearchItems', data.data.Data);
        resolve(data.data.Data);
      }).catch((error) => {
        reject(error)
      });
    });
  },
  updateWebsite: function (context, data) {
    return new Promise((resolve, reject) => {
      Vue.http.post('/accountPlatformDomain/addAccountPlatformDomain', data).then(function (response) {
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getWebsites: function (context, data) {
    var vm = this;
    var query;
    if(data.SearchText) {
      query = "/platform/dealerwebsites?accountId=" + data.AccountId + "&platformId=" + data.PlatformId + "&domainSearchText=" + data.SearchText;
    }
    else {
      query = "/platform/dealerwebsites?accountId=" + data.AccountId + "&platformId=" + data.PlatformId;
    }
    return new Promise((resolve, reject) => {
      //var queryString = "?accountId=" + data.AccountId + "&platformId=" + data.PlatformId + "&domainSearchText=" + data.SearchText;
      Vue.http.get(query).then(function (response) {
        if (response.data.Success) {
          resolve(response.data.Data);
        } else {
          reject(response.data.Messages);
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  deleteWebsite: function (context, data) {
    return new Promise((resolve, reject) => {
      var queryString = "?accountPlatformDomainId=" + data;
      Vue.http.delete('/platform/dealerwebsites' + queryString).then(function (response) {
        resolve(response.data.Data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  verifyIfDomainExists: function (context, domain) {
    let searchRequest = {
      Domain: domain
    }
    return new Promise((resolve, reject) => {
      Vue.http.get('/domain/verify?domain=' + domain).then(function (data) {
        resolve(data.data.Data);
      }).catch((error) => {
        reject(error);
      });
    });
  },
  loadDealersForAccount: function (context, param) {
    var query;
    if(param.allDealers) {
      query = 'account/allplatforms/' + param.accountId;
    }
    else {
      query = 'account/platforms/' + param.accountId;
    }
    return new Promise((resolve, reject) => {
      Vue.http.get(query).then(function (data) {
        context.commit('updateExistingDomains', data.data.Data.sort(HelperFunctions.sortByProperty('Name')));
        resolve(data.data.Data);
      }).catch((error) => {
        reject(error)
      });
    });
  },
  getVendorList: function (context) {
    return new Promise((resolve, reject) => {
      Vue.http.get('websitevendorslite/all').then(function(data){
        context.commit('updateVendorList', data.data.Data.sort(HelperFunctions.sortByProperty('VendorName')));
        resolve(data.data.Data);
      }).catch((error) => {
        reject(error);
      })
    });
  },
  getDuplicateWebsites: function (context, domain) {
    return new Promise((resolve, reject) => {
      Vue.http.get('platform/duplicateWebsite?domain=' + encodeURIComponent(domain)).then(function(data) {
        resolve(data);
      }).catch((error) => {
        reject(error);
      });
    });
  }
};

const mutations = {
  updateRows: function (state, data) {
    state.rows = data;
  },
  toggleAddWebsiteModal: function (state, data) {
    state.showAddWebsiteModal = data;
  },
  setEditingWebsite: function (state, data) {
    state.editingWebsite = data;
  },
  setFilteredRows: function (state, data) {
    state.filteredRows = data;
  },
  updateExistingDomains: function (state, data) {
    state.existingDomains = data;
  },
  updatePlatforms: function (state, data) {
    state.activePlatforms = data;
  },
  updateSearchItems: function (state, data) {
    state.DW_AccountSearchResults = data;
  },
  updateVendorList: function (state, data) {
    state.vendorList = data;
  }
};

const getters = {
  rows: function () {
    return state.rows;
  },
  showAddWebsiteModal: function () {
    return state.showAddWebsiteModal;
  },
  editingWebsite: function () {
    return state.editingWebsite;
  },
  filteredRows: function () {
    return state.filteredRows;
  },
  activePlatforms: function () {
    return state.activePlatforms;
  },
  DW_AccountSearchResults: function () {
    return state.DW_AccountSearchResults;
  },
  multiselectDisabled: function () {
    return state.multiselectDisabled;
  },
  vendorList: function () {
    return state.vendorList;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/DealerWebsites.js